import { Grid, FormHelperText, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { Field } from "formik";

const TextArea = (props) => {
  const { label, name, formik } = props;

  return (
    <Grid>
      <Box
        sx={{
          borderLeft: formik.errors[name] ? "4px solid #ca2e2e" : "",
          paddingLeft: formik.errors[name] ? "16px" : "",
        }}
      >
        <Box display="flex">
          <Box display="flex" my="auto" mr={1}>
            <Field type="checkbox" name="checked" />
          </Box>
          <Typography>{label}</Typography>
        </Box>
        <FormHelperText error>
          <Typography
            variant="body1"
            sx={{
              marginTop: "16px",
              fontWeight: "bolder",
            }}
          >
            {formik.errors[name]}
          </Typography>
        </FormHelperText>
      </Box>
    </Grid>
  );
};

export default TextArea;
